import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    console.log('connect')
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.play()
          } else {
            entry.target.pause()
          }
        })
      },
      {
        threshold: 0.5,
      }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
    this.observer = null
  }
}
